module.exports = __webpack_public_path__ + "img/Analytics.c8063f95.webp";